// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"184":"c20f1ad4","456":"867d8237","479":"d64ed52a","560":"d64ed52a","747":"c20f1ad4","852":"b93f00cc","867":"c20f1ad4","956":"c20f1ad4"}[chunkId] + ".chunk.css";
};